module.exports = __webpack_public_path__ + "1f2e28c25adf3a09c066cf47fa6fcdc3.woff2";